import {
    IDataRequestActionDetailDto,
    IDisclosureActionDetailDto,
    IEnquiryActionDetailDto,
    IUploadActionDetailDto
} from '@vivli/features/dashboard/infrastructure/interface';
import { NoDataActionView } from '../no-data-action.view';
import { gridDataStyle } from './card-styles';
import React, { ReactElement, useEffect } from 'react';

interface ActionContentViewProps {
    count: number;
    actionDetails?: any[];
    noDataMainDescription?: string;
    noDataButtonText?: string;
    children?: ReactElement;
    noDataButtonUrl?: string;
    showGoToButton?: boolean;
    className?: string;
    actionGridComponent?: React.ComponentType<{
        dtos?: IDataRequestActionDetailDto[] | IUploadActionDetailDto | IEnquiryActionDetailDto | IDisclosureActionDetailDto | any[];
    }>;
}

export const ActionContentView = ({
    count,
    actionDetails,
    noDataMainDescription,
    noDataButtonText,
    noDataButtonUrl,
    showGoToButton,
    children,
    className
}: ActionContentViewProps) => {
    const [currentCount, setCurrentCount] = React.useState(count);

    useEffect(() => {
        if (count === null || count === undefined) {
            return;
        }

        setCurrentCount(count);
    }, [count]);

    return currentCount === 0 ? (
        <div style={{ justifySelf: 'center', textAlign: 'center' }} className={className}>
            <NoDataActionView
                mainDescription={noDataMainDescription}
                buttonText={noDataButtonText}
                buttonUrl={noDataButtonUrl}
                showGoToButton={showGoToButton}
            />
        </div>
    ) : (
        <div style={gridDataStyle}>{children}</div>
    );
};
